// Following the Material UI breakpoints https://material-ui.com/customization/breakpoints/
export const breakpointValues = {
  xs: "22.99rem", // 367.84px
  sm: "34.99rem", // 559.84px
  md: "47.99rem", // 767.84px
  lg: "63.99rem", // 1023.84px
  xl: "89.99rem" // 1439.84px
} as const;
export const breakpoints = breakpointValues;

export const hookBreakpoints = {
  mobileXs: `(max-width: ${breakpoints?.xs})`,
  mobileXsMin: `(min-width: ${breakpoints?.xs})`,
  mobile: `(max-width: ${breakpoints?.sm})`,
  mobileMin: `(min-width: ${breakpoints?.sm})`,
  mobileMax: `(max-width: ${breakpoints?.md})`,
  tablet: `(min-width: ${breakpoints?.md}) and (max-width: ${breakpoints?.lg})`,
  tabletMax: `(max-width: ${breakpoints?.lg})`,
  desktop: `(min-width: ${breakpoints?.lg}) and (max-width: ${breakpoints?.xl})`,
  desktopMax: `(max-width: ${breakpoints?.xl})`,
  extraLarge: `(min-width: ${breakpoints?.xl})`
};
